/** The category titles. */
export const categoryTitles = {
    favorite: 'Favorites',
    frequent: 'Frequently used',
    recent: 'Recently used',
    paginated: 'All',
};
